// maintenanceFallback.js
import APP_CONFIG from "../../config";

export const maintenanceFallback = {
    enabled: true,

    hero: {
        badge_icon: "🛠️",
        badge_text: "Maintenance en cours",
        title: "TheSustain revient très bientôt",
        subtitle: "Semer sur la terre pour récolter dans les cieux",
        description: `Notre plateforme est momentanément indisponible afin
d’améliorer votre expérience spirituelle.
Merci pour votre patience et vos prières 🙏`,
        floating_badge: {
            icon: "🕊️",
            text: "À très bientôt",
        },
    },

    card: {
        icon: "⏳",
        title: "Amélioration de la plateforme",
        text:
            "Nouvelles fonctionnalités, performances optimisées et expérience encore plus spirituelle.",
        features: [
            {
                icon: "🙏",
                label: "Prière",
                description:
                    "Un espace dédié à la prière personnelle et communautaire. Déposez vos intentions, soutenez d'autres membres et recevez des notifications lorsque quelqu’un prie pour vous."
            },
            {
                icon: "📖",
                label: "Bible",
                description:
                    "Accédez aux Écritures, plans de lecture, méditations guidées et commentaires pour approfondir votre foi quotidiennement."
            },
            {
                icon: "📔",
                label: "Journal",
                description:
                    "Un journal spirituel privé pour écrire vos réflexions, révélations et témoignages. Votre espace personnel de croissance intérieure."
            },
            {
                icon: "🤍",
                label: "Communauté",
                description:
                    "Rejoignez une communauté chrétienne engagée. Partagez, échangez, témoignez et grandissez ensemble dans la foi."
            },
        ],
    },
      newsletter: {
          // Version normale (active)
          title: "📬 Prêt à grandir dans la foi ?",
          description: "Rejoignez des milliers de chrétiens qui utilisent TheSustain pour approfondir leur relation avec Dieu à travers des encouragements, études bibliques et témoignages.",
          cta_title: "Abonnez-vous à notre newsletter",
          cta_description: "Recevez chaque semaine des méditations, enseignements et histoires inspirantes directement dans votre boîte mail.",
          button_submit_text: "S'abonner",
          placeholder: "Votre adresse email",
          success_message: "Merci 🙏 Vous êtes maintenant inscrit pour recevoir notre newsletter !",
          error_message: "Une erreur est survenue. Réessayez.",

          title_in_maintenance: "📬 Recevoir notre newsletter",
          description_in_maintenance: "Encouragements, études bibliques et annonces importantes.",
          cta_title_in_maintenance: "Soyez informé de la réouverture",
          cta_description_in_maintenance: "Abonnez-vous à notre PubMag trimestriel : études bibliques, témoignages et retours d'expériences",
          button_submit_text_in_maintenance: "Être informé",
          placeholder_in_maintenance: "Votre adresse email",
          success_message_in_maintenance: "Merci 🙏 Vous serez informé dès la réouverture.",
          error_message_in_maintenance: "Une erreur est survenue. Réessayez."
      },


    ACESS_PERMISSION: APP_CONFIG.ACESS_USERS,
};
export  const  ACESS_PERMISSION = maintenanceFallback.ACESS_PERMISSION;